import { api } from "@/lib/api";

const b64ToBytes = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// Ask permission (must run from a tap) and register this phone for alerts.
export async function enablePush() {
  if (!pushSupported()) return "unsupported";
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return perm;
  await syncPush();
  await api.post("/push/test");
  return "granted";
}

// Already allowed: make sure the server has this phone's subscription.
export async function syncPush() {
  if (!pushSupported() || Notification.permission !== "granted") return;
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.key) });
  }
  await api.post("/push/subscribe", sub.toJSON());
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (tz) await api.put("/push/prefs", { tz });
}
